import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';

import ShowcaseBtn from '../../src/media/ShowcaseBtn.jsx';

let domDeleteEl = document.querySelectorAll('.ShowcaseBtn');
let media;
if (preloaded.video) media = preloaded.video;
if (preloaded.picture) media = preloaded.picture;

if (domDeleteEl) {
  domDeleteEl.forEach( el => {
    ReactDOM.render(<ShowcaseBtn media={media} el={el} />, el);
  });
}